import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import {
  fetchAoeLoincData,
  addNewAoeLoinc,
  updateAoeLoincRecord,
  removeAoeLoincRecord,
  fetchAoeLoincById,
} from "../services/aoeLoincCodes-service";
import { aoeLoincHeadCells } from "../util/headcells-util";
import { handleIsActive } from "../util/common";
import _ from "lodash";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { AOELTRB } from "../util/component-codes";
import Cookies from "js-cookie";
import { FixedSizeList } from "react-window";

const AOELoincCodes = () => {
  const [show, setShow] = useState(false);

  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [form, setForm] = useState({});
  const [alertMessage, setAlertMessage] = useState();

  const [filter, setFilter] = useState({});
  const [isAddNew, setIsAddNew] = useState(false);

  const [validated, setValidated] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modifiedRow, setModifiedRow] = useState(null);
  const [aoeLoincData, setAoeLoincData] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [valueTypeCodes, setValueTypeCodes] = useState([]);
  const [valueTypeCodesCheckedValues, setValueTypeCodesCheckedValues] =
    useState([]);
  const [codeSets, setCodeSets] = useState([]);
  const [codeSetsCheckedValues, setCodeSetsCheckedValues] =
    useState([]);

  const handleClose = () => setShow(false);
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const [user] = useContext(UserContext);

  const urlWithParams = (filter) => {
    let loincCode = filter?.searchLoincText ? filter?.searchLoincText : "";
    let dataType = filter?.dataType?.length > 0 ? filter?.dataType : [];
    let codeSet = filter?.codeSet?.length > 0 ? filter?.codeSet : [];
    let isActive = [];

    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (loincCode !== "") {
      params += `&aoeLoincCode=${loincCode}`;
    }
    if (dataType.length > 0) {
      params += `&dataType=${dataType.toString()}`;
    }
    if (codeSet.length > 0) {
      params += `&codeSet=${codeSet.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const handleCheckboxChange = (
    newValue,
    conditionCheckedValues,
    setConditionCheckedValues,
    filter
  ) => {
    let copyCheckedValues = [...conditionCheckedValues];

    if (copyCheckedValues.includes(newValue)) {
      copyCheckedValues = copyCheckedValues.filter((item) => item !== newValue);
    } else {
      copyCheckedValues = [...copyCheckedValues, newValue];
    }
    setConditionCheckedValues(copyCheckedValues);
    setFilterField(filter, copyCheckedValues);
  };

  const getAoeLoincData = useCallback(
    async (filter) => {
      let response = await fetchAoeLoincData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          setAoeLoincData(data);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const addAoeLoinc = async () => {
    let data = await addNewAoeLoinc(form);
    if (data.aoeLoincId != null) {
      setModifiedRow(data.aoeLoincCode);
      setIsAdded(true);
    } else {
      setIsError(true);
      setAlertMessage(data?.description);
    }
  };

  const updateAoeLoinc = async () => {
    let data = await updateAoeLoincRecord(form);
    if (data.aoeLoincId != null) {
      setSelectedRow(data);
      setModifiedRow(data.aoeLoincCode);
      setIsUpdated(true);
    } else {
      setIsError(true);
      setAlertMessage(data?.description);
    }
  };

  const removeAoeLoinc = async () => {
    let response = await removeAoeLoincRecord(selectedRow.aoeLoincId);
    if (response !== ERROR_MSG) {
      setIsDeleted(true);
      setSelectedRow(null);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
  };

  const getValueTypeCodes = async () => {
    let response = await fetchCodeSetTable("Value Type");

    if (response.ok) {
      let data = await response.json();
      if (data?.refTableValues.length > 0) {
        setValueTypeCodes(data.refTableValues);
      } else {
        setIsFetchError(true);
        setIsError(true);
        setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const getSetCodes = async () => {
    let response = await fetchCodeSetTable("Code Set");

    if (response.ok) {
      let data = await response.json();
      if (data?.refTableValues.length > 0) {
        setCodeSets(data.refTableValues);
      } else {
        setIsFetchError(true);
        setIsError(true);
        setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  useEffect(() => {
    if (pageNo >= aoeLoincData?.totalPages) {
      aoeLoincData?.totalPages !== 0 && setPageNo(aoeLoincData?.totalPages - 1);
    }
  }, [aoeLoincData]);

  useEffect(() => {
    getAoeLoincData(filter);
  }, [pageNo, recordsPerPage, getAoeLoincData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getAoeLoincData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getAoeLoincData]);

  useEffect(() => {
    getValueTypeCodes();
    getSetCodes();
  }, []);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleAdd = () => {
    setForm({});
    setValidated(false);
    setIsAddNew(true);
    setShow(true);
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
  };
  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = async () => {
    let response = await fetchAoeLoincById(selectedRow.aoeLoincId);

    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setForm(data);
        setValidated(false);
        setIsAddNew(false);
        setShow(true);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };
  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleSubmmit = (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      isAddNew ? addAoeLoinc() : updateAoeLoinc();
      setShow(false);
    }
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getAoeLoincData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setValueTypeCodesCheckedValues([])
    setCodeSetsCheckedValues([])
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(AOELTRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null && !isError}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted AOE LOINC record";
    } else if (isAdded) {
      return (
        "New AOE LOINC code : " + modifiedRow + " has been successfully added!"
      );
    } else if (isUpdated) {
      return (
        "AOE LOINC code : " + modifiedRow + " has been successfully updated!"
      );
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (valueTypeCodesCheckedValues.length > 0) {
      active.push("0");
    }
    if (codeSetsCheckedValues.length > 0) {
      active.push("1");
    }
    if (filter?.active || filter?.inactive) {
      active.push("2");
    }
    return active;
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">AOE LOINC Table</Row>
            <Row className="tableSubtitle generalFont">
              View all the Ask of Order Entry LOINC codes available to you
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={aoeLoincHeadCells}
          rows={aoeLoincData?.genericList}
          pages={aoeLoincData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New AOE LOINC"
          addButtonAction={handleAdd}
          closeButtonAction={handleClose}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isAoeLoincTable={true}
        />
      </Container>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              {isAddNew ? "Add New AOE LOINC" : "Update AOE LOINC"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.aoeLoincCode">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      LOINC Code <i className="text-danger">(required)</i>
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    maxLength={25}
                    placeholder="Hint Text"
                    autoFocus
                    required
                    value={form.aoeLoincCode}
                    onChange={(e) => setField("aoeLoincCode", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.responseDatatype">
                  <Form.Label className="modalLabel generalFont">
                    Response Data Type <i className="text-danger">(required)</i>
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={form.responseDatatype}
                    onChange={(e) => {
                      setForm({
                        ...form,
                        responseDatatype: e.target.value,
                        valueSetName:
                          e.target.value !== "CWE" ? "" : form.valueSetName,
                      });
                    }}
                    feedback="You must agree before submitting."
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    {_.sortBy(valueTypeCodes, ["reference_code"]).map(
                      (entry) => {
                        return (
                          <option
                            key={entry.referenceTableValueId}
                            value={entry.reference_code}
                          >
                            {entry.reference_code}
                          </option>
                        );
                      }
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.valueSetName">
                  <Form.Label className="modalLabel generalFont">
                    Value Set Name{" "}
                    {form.responseDatatype === "CWE" && (
                      <i className="text-danger">(required)</i>
                    )}
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={form.valueSetName}
                    onChange={(e) => setField("valueSetName", e.target.value)}
                    feedback="You must agree before submitting."
                    disabled={form.responseDatatype !== "CWE"}
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    {_.sortBy(codeSets, ["reference_code"]).map((entry) => {
                      return (
                        <option
                          key={entry.referenceTableValueId}
                          value={entry.reference_code}
                        >
                          {entry.reference_code}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="form.aoeLoincLongName">
              <Form.Label className="modalLabel generalFont">
                LOINC Long Name <i className="text-danger">(required)</i>
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                type="text"
                maxLength={50}
                placeholder="Hint Text"
                required
                value={form.aoeLoincLongName}
                onChange={(e) => setField("aoeLoincLongName", e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="form.description">
              <Form.Label className="modalLabel generalFont">
                Description
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                type="text"
                maxLength={250}
                placeholder="Hint Text"
                value={form.description}
                onChange={(e) => setField("description", e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.isActive">
                  <Form.Label className="modalLabel generalFont">
                    Status <i className="text-danger">(required)</i>
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={handleIsActive(form.isActive)}
                    onChange={(e) =>
                      setField(
                        "isActive",
                        e.target.value === "Active" ? true : false
                      )
                    }
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="form.comments">
              <Form.Label className="modalLabel generalFont">
                Admin Comments
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                as="textarea"
                maxLength={250}
                rows={3}
                value={form.comments}
                onChange={(e) => setField("comments", e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              {isAddNew ? "Add" : "Update"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove AOE LOINC
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this AOE LOINC Code from the
              Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeAoeLoinc}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search LOINC Code"
                value={filter.searchLoincText ? filter.searchLoincText : ""}
                onChange={(e) =>
                  setFilterField("searchLoincText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Response Data Type</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        valueTypeCodes.sort((a, b) =>
                          a.reference_code.localeCompare(b.reference_code)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={valueTypeCodesCheckedValues.includes(
                                  valueTypeCodes[index].reference_code
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    valueTypeCodes[index].reference_code,
                                    valueTypeCodesCheckedValues,
                                    setValueTypeCodesCheckedValues,
                                    "dataType"
                                  )
                                }
                                name={valueTypeCodes[index].reference_code}
                              />
                            }
                            label={valueTypeCodes[index].reference_code}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Value Set Name</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        codeSets.sort((a, b) =>
                          a.reference_code.localeCompare(b.reference_code)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={codeSetsCheckedValues.includes(
                                  codeSets[index].reference_code
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    codeSets[index].reference_code,
                                    codeSetsCheckedValues,
                                    setCodeSetsCheckedValues,
                                    "codeSet"
                                  )
                                }
                                name={codeSets[index].reference_code}
                              />
                            }
                            label={codeSets[index].reference_code}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AOELoincCodes;
